import { lazy } from "react";

import "@mobx/pages/Locations3";

const Home = lazy(() => import("@components/Pages/NewPages/Home"));
const Login = lazy(() => import("@components/Pages/Login/Login"));
const User = lazy(() => import("@components/Pages/User/User"));
const Machines = lazy(() => import("@components/Pages/Machines/Machines"));
const Clients = lazy(() => import("@components/Pages/Clients/Clients"));
const Settings = lazy(() => import("@components/Pages/Settings/Settings"));

const Locations = lazy(() => import("@mobx/pages/Locations3"));

const Contracts = lazy(() => import("@components/Pages/Managment/Managment"));
const Messenger = lazy(() => import("@components/Pages/Messenger/Messenger"));
const Notifications = lazy(() => import("@components/Pages/Notifications/Notifications"));
const Scanreport = lazy(
  () => import("@components/Pages/Scanreport/Scanreport")
);
const Params = lazy(() => import("@components/Pages/Params/Params"));
const Error404 = lazy(() => import("@components/Pages/404/Error404"));
const Error = lazy(() => import("@components/Pages/Error/Error"));
const Info = lazy(() => import("@components/Pages/Info/Info"));
const SpareParts = lazy(() => import("@components/Pages/SpareParts/SpareParts"));
// testing
const TestChart = lazy(() => import("@components/Pages/TestChart/TestChart"));

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Home,
  Login,
  User,
  Machines,
  Clients,
  Settings,
  Locations,
  Contracts,
  Messenger,
  Notifications,
  Params,
  Error404,
  Error,
  Info,
  Scanreport,
  SpareParts,
  // testing
  TestChart,
};
